export default __webpack_public_path__ + "static/media/ante&bet.8b6341b0.svg";